import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const nniDataFields: FieldInterface[] = [
  {
    key: 'advisor',
    originKey: 'advisor',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
    objectType: 'Advisor',
    objectTypePath: 'src/services/mappings/nniData/nniData.types',
  },
]

const nniDataRelations: RelationInterface[] = []

export { nniDataFields, nniDataRelations }
